import { keys } from './keys';

export const es = {
  [keys.english]: 'EN',
  [keys.spanish]: 'ES',
};
